import api from './api';

// Kural tabanlı atama (AKM POC §6.2) — backend PolicyRuleController (`v1/policy-rules`).
// kind ∈ workPlan | leavePolicy | overtimePolicy | complianceProfile | holidayCalendar.
// Yetki türün modülünden gelir (çalışma planı / tatil takvimi EM, izin politikası LM, fazla mesai TA,
// uyum profili SM); okuma Read, yazma Write.

export const list = (kind, policyId, page = 1, size = 10) => api.get('/v1/policy-rules', {
  params: { kind, policyId, pageNumber: page, pageSize: size },
});

export const create = (body) => api.post('/v1/policy-rules', body);

export const update = (id, body) => api.put(`/v1/policy-rules/${id}`, body);

export const remove = (id) => api.delete(`/v1/policy-rules/${id}`);

// Eski kişi başı atama (UserWorkPlan / User.LeavePolicyId / Employee.HolidayCalendarId). userId listede
// gelen legacy satırın targetId'sidir (login User.Id ya da Employee.Id — sunucu ikisini de tanır).
export const removeLegacy = (kind, userId) => api.delete(`/v1/policy-rules/legacy/${kind}/${userId}`);

// Politikanın eski kişi başı atama SAYISI (yalnız workPlan | leavePolicy | holidayCalendar türlerinde eski
// satır olur). Yanıt { count }; okuma yetkisi (türün modülünde Read).
export const legacyCount = (kind, policyId) => api.get('/v1/policy-rules/legacy-count', {
  params: { kind, policyId },
});

// Politikanın TÜM eski kişi başı atamalarını kaldırır (kişiler kurallara / varsayılana düşer). Yanıt
// { removedCount }; yazma yetkisi.
export const removeAllLegacy = (kind, policyId) => api.delete(`/v1/policy-rules/legacy/${kind}`, {
  params: { policyId },
});

// "Kim hangi kuralı alıyor?" — date verilmezse sunucu bugünü (TR) kullanır.
export const effective = (kind, employeeId, date) => api.get('/v1/policy-rules/effective', {
  params: date ? { kind, employeeId, date } : { kind, employeeId },
});

const policyRuleService = {
  list, create, update, remove, removeLegacy, legacyCount, removeAllLegacy, effective,
};

export default policyRuleService;
